declare type AssortmentInterfaceIndex = string
declare type AssortmentInterface = Record<AssortmentInterfaceIndex, string[]>

const assortments: AssortmentInterface = {
  satch: ['backpacks', 'books', 'freeTime', 'school'],
  ergobag: [],
  affenzahn: ['shoes', 'backpacks', 'freeTime', 'bikes'],
}

export default assortments
